import { fetchAuthSession } from 'aws-amplify/auth'

const getBaseUrl = () => process.env.REACT_APP_API_URL

async function authHeaders() {
  const { tokens } = await fetchAuthSession()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokens.idToken.toString()}`,
  }
}

export const api = {
  async getInvestments() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/investments`, { headers })
    if (!res.ok) throw new Error('Failed to fetch investments')
    const { investments } = await res.json()
    return investments.map(({ id, purchase_date, trade_data }) => ({
      id,
      purchase_date,
      ...trade_data,
    }))
  },

  async postInvestment(data) {
    const headers = await authHeaders()
    const { account, symbol, purchase_date, account_type, quantity, purchase_price } = data
    const res = await fetch(`${getBaseUrl()}/investments`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        account,
        symbol,
        purchase_date,
        trade_data: { account_type, quantity, purchase_price },
      }),
    })
    if (!res.ok) throw new Error('Failed to create investment')
    return res.json()
  },

  async putInvestment(id, purchaseDate, data) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/investments/${id}/${purchaseDate}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to update investment')
    return res.json()
  },

  async deleteInvestment(id, purchaseDate) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/investments/${id}/${purchaseDate}`, {
      method: 'DELETE',
      headers,
    })
    if (!res.ok) throw new Error('Failed to delete investment')
  },
}
